import React, { useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';
import '../styles/Escrow.css';
import Loader from '../components/Loader';

const Escrow = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        try {
          const userDocRef = doc(db, 'users', firebaseUser.uid);
          const userDoc = await getDoc(userDocRef);
          if (userDoc.exists()) {
            const userData = userDoc.data();
            setUser({
              uid: firebaseUser.uid,
              fullName: userData.fullName || 'John Doe',
              email: userData.email || 'johndoe@email.com',
            });
          } else {
            console.error('No user doc found');
          }
        } catch (error) {
          console.error('Error fetching fullName:', error);
        }
      }
    });

    return () => unsubscribe();
  }, []);

  const getInitials = (name) => {
    if (!name) return '';
    const parts = name.trim().split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return parts[0].substring(0, 2).toUpperCase();
  };

  const handleStartEscrow = () => {
    if (user?.uid) {
      window.open(`https://escrow.skyhighntb.com/start/${user.uid}`, '_blank');
    }
  };

  return (
    <div className="escrow-container">
      <div className="escrow-box">
        <h1 className="escrow-title">What is Escrow?</h1>
        <p className="escrow-description">
          Escrow is a secure financial arrangement where a neutral third party holds funds until both the buyer and seller meet the agreed-upon terms. It protects both sides from fraud, disputes, or incomplete transactions.
        </p>

        <div className="steps-section">
          <h2 className="steps-title">How It Works:</h2>
          <ol className="steps-list">
            <li><strong>Search for a user:</strong> Head to the All Users page and find the person by name or email.</li>
            <li><strong>Go to their profile:</strong> Click on their card to view their details.</li>
            <li><strong>Start escrow:</strong> Use the "Start Escrow" button to fill in the transaction details and conditions.</li>
            <li><strong>Release funds:</strong> Once both parties meet all requirements, release the funds securely.</li>
          </ol>
        </div>

        {user ? (
          <div className="my-info">
            <div className="avatar">{getInitials(user.fullName)}</div>
            <div className="details">
              <h2 className="full-name">{user.fullName}</h2>
              <p className="user-id">User ID: <span>{user.uid}</span></p>
              <p className="user-id">Email: <span>{user.email}</span></p>
            </div>
          </div>
        ) : (
          <Loader />
        )}

        <button
          className="start-escrow-button"
          onClick={handleStartEscrow}
          disabled={!user}
        >
          Start Escrow
        </button>
      </div>
    </div>
  );
};

export default Escrow;
